import React from 'react';
import { Spring, animated } from 'react-spring';

import styles from './style.css';

const JobsDesigner = () => (
  <div className={styles.jobs}>
    <Spring
      native
      from={{ opacity: 0, transform: 'translateX(-50%)' }}
      to={{ opacity: 1, transform: 'translateX(0%)' }}
    >
      {style => (
        <animated.div style={style} className={styles.jobs__text__wrapper}>
          <div className={styles.jobs_text}>
            Junior <span>Designer</span>
          </div>
        </animated.div>
      )}
    </Spring>
    <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }} delay={500}>
      {style => (
        <animated.div style={style} className={styles.jobs__description}>
          <p>
            Play a key role in designing native apps for amazing clients from
            around the world; join our team in the heart of Cluj-Napoca and
            deliver for the best at an agency recognized by Google.
          </p>
          <p>
            <strong>Requirements </strong>
            6+ months experience with Figma, Sketch or similar in personal or
            commercial projects / in love with patterns / pixel perfect
            enthusiast
          </p>
          <a
            className={styles.apply__button}
            href="mailto:hello@wearewip.com?Subject=Junior Designer Job Application"
          >
            Apply Now
          </a>
        </animated.div>
      )}
    </Spring>
  </div>
);

export default JobsDesigner;
